/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Comments_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Comments (optional)" |
*
* @param {Deck_Comments_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_comments_placeholder = /** @type {((inputs?: Deck_Comments_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Comments_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commentaires (optionnel)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comentarios (opcional)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Comentários (opcional)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Commenti (facoltativo)")
	return /** @type {LocalizedString} */ ("Comments (optional)")
});